export default "__VITE_ASSET__OvxDE9v0__"